<template>
    <div>
        <form-label-title label="Position"></form-label-title>
        <div class="position-input-container">
            <div class="position-item-input-container">
                <span class="position-label position-label-left-col">Top</span>
                <form-input-float size="mini" :inputValue.sync="top_value"></form-input-float>
            </div>
            <div class="position-item-input-container">
                <span class="position-label position-label-right-col">Bottom</span>
                <form-input-float size="mini" :inputValue.sync="bottom_value"></form-input-float>
            </div>
            <div class="position-item-input-container">
                <span class="position-label position-label-left-col">Left</span>
                <form-input-float size="mini" :inputValue.sync="left_value"></form-input-float>
            </div>
            <div class="position-item-input-container">
                <span class="position-label position-label-right-col">Right</span>
                <form-input-float size="mini" :inputValue.sync="right_value"></form-input-float>
            </div>
        </div>
    </div>
</template>

<script>
import FormLabelTitle from '@/components/Form/FormLabelTitle'
import FormInputFloat from '@/components/Form/FormInputFloat'

    export default {
        components: {
            'form-label-title': FormLabelTitle,
            'form-input-float': FormInputFloat,
        },
        props: {
            left: {
                type: String | Number
            },
            top: {
                type: String | Number
            },
            right: {
                type: String | Number
            },
            bottom: {
                type: String | Number
            },
        },
        computed: {
            left_value: {
                set(val){
                    this.$emit('update:left', val)
                },
                get(){
                    return this.left
                }
            },
            top_value: {
                set(val){
                    this.$emit('update:top', val)
                },
                get(){
                    return this.top
                }
            },
            right_value: {
                set(val){
                    this.$emit('update:right', val)
                },
                get(){
                    return this.right
                }
            },
            bottom_value: {
                set(val){
                    this.$emit('update:bottom', val)
                },
                get(){
                    return this.bottom
                }
            },
        },
    }
</script>

<style scoped>
.position-input-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, 1fr);
    grid-gap: 10px;
    margin: 8px 0 16px 0;
}
.position-item-input-container {
    display: flex;
    align-items: center;
}
.position-label {
    font-size: 11px;
    color: var(--description-grey);
}
.position-label-left-col {
    width: 60px;
}
.position-label-right-col {
    width: 90px;
}
</style>


// WEBPACK FOOTER //
// src/components/SidebarDetail/EchartConfiguration/PositionInput.vue